<template>
    <div>
    <div style="height: 110px;border-bottom: 1px solid #f2f2f2">
        <div class="logo-con">
            <img src="@/assets/title.png" alt="" style="height: 40px;padding: 30px 60px;">
            <div class="logo-title">找回密码</div>
        </div>
    </div>
        <div class="formmain">

            <!--手机号-->
    <el-form ref="form" :model="form" label-width="80px" v-if="isshow">
        <el-form-item>
            <el-input v-model="form.mobile" placeholder="请输入手机号" @blur="slide"></el-input>
        </el-form-item>
        <!--<el-form-item>
            &lt;!&ndash; 拼图 &ndash;&gt;
            <div v-if="flag" class="testCode">
                <p class="closeBtn" style="align-items: center;">
                    <span class="closetip">完成拼图验证</span>
                    <i class="el-icon-close" @click="flag = !flag" style="padding-right: 10px"></i>
                </p>
                <slide-verify
                        :l="42"
                        :r="20"
                        :w="320"
                        :h="140"
                        slider-text="向右拖住滑块填充拼图"
                        @success="
                        "
                        @fail="onFail"
                        @refresh="onRefresh"
                        class="slide-box"
                        ref="slideBlock"
                ></slide-verify>
            </div>
            <div  @click="slide()" class="btn-check-defaut" v-if="isslide">点击进行验证
            </div>
            <div  class="btn-check-succ" v-if="sucessshow">验证成功
            </div>
        </el-form-item>-->
        <el-form-item>
            <el-button type="primary" @click="commmitdown()" class="loginbtn" :disabled="!isdown">下一步
            </el-button>
        </el-form-item>


        </el-form>
<!--新密码-->
            <el-form ref="formpwd" :model="formpwd"  label-width="80px" v-if="pwdshow" class="getpwd">

                <el-form-item prop="password">
                    <el-input v-model="formpwd.password" placeholder="设置新密码" type="password" prefix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item prop="verifypwd">
                    <el-input v-model="formpwd.verifypwd" placeholder="确认新密码" type="password" prefix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getvalidate('formpwd')" class="loginbtn">确定
                    </el-button>
                </el-form-item>

            </el-form>
        </div>

        <el-dialog title="安全验证" :visible.sync="dialogFormVisible" style="width: 45%;margin: 0 auto;overflow: hidden">
            <div style="padding-bottom: 10px">验证方式</div>
            <el-form ref="formphone" :model="formphone"  style="">
            <el-form-item prop="vc_mobile">
                <el-input v-model="formphone.vc_mobile" placeholder="手机号" disabled></el-input>
            </el-form-item>

            <el-form-item class="code" prop="vc_code">
                <el-input v-model="formphone.vc_code" placeholder="请输入验证码" style="width: 48%"></el-input>
                <el-button type="button" @click="sendvalidatecode" style="margin: 0 0 0 10px;width: 48%" :disabled="!show"
                           :class="issend?'disabledbtn':''">
                    {{btntitle}}
                </el-button>
            </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitvalidate()" class="loginbtn">确定
                    </el-button>
                </el-form-item>
                </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api";
    import md5 from 'js-md5';
    export default {
    data() {
        return {
            issend:false,
            flag: false,
            isSuccess: "false",
            dialogFormVisible:false,
            show: true,
            btntitle: "发送验证码",
            timer: null,
            isshow:true,
            pwdshow:false,
            sucessshow:false,
            isslide:true,
            isdown:false,
            getusername:'',
            form: {
                mobile: '',
            },
            formphone:{
                vc_mobile:'',
                vc_code:''
            },
            formpwd:{
                password:'',
                verifypwd:'',
                vc_login:'',
            },
        }
    },
        watch:{

        },
    methods: {
        touchStartEvent(e){

        },
        slide(){
            var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
            if(this.form.mobile=="") {
                this.$message.error("手机号不能为空");
                this.isdown=false
            }else  if( !reg.test(this.form.mobile)){
                this.$message.error("手机号码有误，请重填");
                this.form.mobile=""
                this.isdown=false
                return false;
            }else {
                this.isdown=true
                // this.flag=true;
            }
        },

        // 拼图成功
        onSuccess() {
            this.isSuccess = true;
            this.flag=false;
            this.isslide=false
            this.sucessshow=true
            this.isdown=true


        },
        // 拼图失败
        onFail() {
            this.isSuccess = false;
        },
        // 拼图刷新
        onRefresh() {
        },
        //下一步
        async commmitdown() {
                sessionStorage.setItem("phone",this.form.mobile);
                this.formphone.vc_mobile=sessionStorage.getItem('phone');
            let param = {
                vc_mobile: this.form.mobile,
            };
            let res = await API.getUserLogin(param);
            if (res.code == 1) {
                this.dialogFormVisible=true;
                this.getusername=res.vc_login;
            }
        },
        //获取验证码
        async sendvalidatecode() {
            let param = {
                vc_mobile: this.formphone.vc_mobile,
                type:2,
            };
            let res = await API.getVerficationCode(param);
            if (res.code == 1) {
                this.$message.success(res.message);
                this.show = false;
            } else if(res.code==-2){
                this.$router.push('/login')
                this.$message.error(res.message);
            }else {
                this.$message.error(res.message);
            }
            let time = 60;
            let timer = setInterval(() => {
                if (time == 0) {
                    clearInterval(timer);
                    this.btntitle = "发送验证码";
                    this.show = true;
                    this.issend=false
                } else {
                    this.issend=true
                    this.btntitle = time + "秒后重试";
                    time--;
                    this.show = false;
                }
            }, 1000)
        },
        async submitvalidate(){
            let param = {
                vc_mobile: this.formphone.vc_mobile,
                vc_code:this.formphone.vc_code,
                type:2,
            };
            let res = await API.getvalidatecode(param);
            if (res.code == 1) {
                this.$message.success(res.message);
                this.dialogFormVisible=false;
                this.isshow=false;
                this.pwdshow=true;

            } else if(res.code==-2){
                this.$router.push('/login')
                this.$message.error(res.message);
            }else {
                this.$message.error(res.message);
                this.formphone.vc_code=""

            }

        },
        //设置新密码
     async  getvalidate(formpwd){
         var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
                if(this.formpwd.password==""){
                    this.$message.error("密码不能为空");
                }else if (!regex.test(this.formpwd.password)) {
                    this.$message.error("密码中必须大于6位,包含数字、字母");
                    this.formpwd.password="";
                    this.formpwd.verifypwd="";
                }else if(this.formpwd.verifypwd==""){
                    this.$message.error("确认密码不能为空");
                }else if(this.formpwd.password!==this.formpwd.verifypwd){
                    this.$message.error("两次密码不一致");
                    this.formpwd.password="";
                    this.formpwd.verifypwd="";
                }else{
                    var mdpwd=md5(this.getusername+this.formpwd.password)
                    let param = {
                        vc_mobile: this.formphone.vc_mobile,
                        vc_pwd:mdpwd.toUpperCase(),
                    };
                    let res = await API.getupdatePwd(param);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        this.$router.push("/login");

                    } else if(res.code==-2){
                        this.$router.push('/login')
                        this.$message.error(res.message);
                    }else {
                        this.$message.error(res.message);
                        this.formphone.vc_code=""

                    }
                }

        },

    }
    }

</script>
<style scoped>
    .logo-con {
        width: 80%;
        margin: 0 auto;
        height: 120px;
        display: flex;
        align-items: center;
    }
    .el-form-item {
        margin-bottom: 30px;
    }
    .disabledbtn{
        background: #f6f6f6!important;
        color: #666!important;
    }
    .formmain {
        width: 402px;
        margin: 0 auto;
        margin-top: 240px;
    }
    .logo-title {
        float: left;
        height: 34px;
        line-height: 34px;
        font-size: 24px;
        color: #333;
    }

    .form-wrap {
        width: 402px;
        margin: 0 auto;
        margin-top: 65px;
    }
    .loginbtn{
        width: 100%;
        color: #fff;
        background: #E89112;
        border-color: #E89112;
    }
    .el-dialog__header{
        border-bottom: 1px solid #f2f2f2;
    }
   .getpwd .el-form-item{
        width: 400px;
    }
    .testCode{
        position: absolute;
        top: -308px;
    }
    .slide-verify-slider{
        width: 320px!important;
    }
    .btn-check-defaut {
        width: 100%;
        background: #f3f3f3;
        border: 1px solid #ccc;
        font-size: 14px;
        color: #999;
        letter-spacing: -.25px;
        text-align: center;
    }
    .closeBtn{
        display: flex;
        justify-content: space-between;
    }
    .closetip{
        font-size: 14px;
        color: #666;
        padding: 0 10px;
    }
    .btn-check-succ{
        background: #fff;
        border: 1px solid #ccc;
        font-size: 14px;
        color: #0c8;
        text-align: center;
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #FFF;
        background-color: #E89112;
        border-color: #E89112;
        opacity: 0.5;

    }
</style>